import http from '@/shared/config/httpService';

export default class SetupService {
  /**
   * setup all settings
   */
  public async setup(): Promise<any> {
    return await http.post('/api/setup-insurances');
  }

  /**
   *
   * do setup if not already done
   *
   */
  public async checkSetup(): Promise<any> {
    return await http.post('/api/setup-insurances/check');
  }
}
